var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17C16 14.8526 13.3135 13.1111 10 13.1111C6.6865 13.1111 4 14.8526 4 17M10 10.7778C9.00544 10.7778 8.05161 10.3681 7.34835 9.63875C6.64509 8.90944 6.25 7.92029 6.25 6.88889C6.25 5.85749 6.64509 4.86834 7.34835 4.13903C8.05161 3.40972 9.00544 3 10 3C10.9946 3 11.9484 3.40972 12.6517 4.13903C13.3549 4.86834 13.75 5.85749 13.75 6.88889C13.75 7.92029 13.3549 8.90944 12.6517 9.63875C11.9484 10.3681 10.9946 10.7778 10 10.7778Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.1d09e078201cf9765c881d1ce0c0d268.svg";
export { ForwardRef as ReactComponent };